import React from 'react';
import useActionNetworkForm from '../../../hooks/useActionNetworkForm';

import './styles.scss';

function FormBlock({ block }) {
  const { headline, backgroundImage, form } = block;
  const bgImageUrl = backgroundImage?.url;

  const { formId } = useActionNetworkForm(form);

  return (
    <div className={`form-block-wrapper`} style={{ backgroundImage: `url(${bgImageUrl})` }}>
      <div className="container">
        <div className="wrapper">
          <div className="content">
            <h2>{headline}</h2>

            {form && <div id={formId} className="iframe-form" />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormBlock;
